global.jQuery = require('jquery');
require('bootstrap/js/tooltip');
require('bootstrap/js/popover');
var Marionette = require('backbone.marionette');

// Adds bootstrap popover on view:show and destroys it on view:destroy

var Popover = Marionette.Behavior.extend({
    ui: {
        popover: '[data-toggle="popover"]',
    },
    onRender: function() {
        this.ui.popover.popover();
    },
    onBeforeDestroy: function() {
        this.ui.popover.popover('destroy');
    },
});

module.exports = Popover;
